import * as React from 'react';
import { Schema, SchemaField } from '../../../types/Metadata';
import { SixDots } from '../../Icon/icon';
import { Arrow } from 'rcd-cpp-ui/ui/icon';
import { cn, dndCardDetails } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';
import { ItemFieldCardWrapper } from './itemFieldCardWrapper';

interface Props {
  field: SchemaField;
  schemaForm?: Schema;
  index: number;
  onMove?: (index1: number, index2: number) => void;
  isDisabled: boolean;
  children?: React.ReactNode;
}

export const getGroupChildren = (field: SchemaField, fields: SchemaField[]) => {
  return fields.filter(f => f.parentField == field.field);
};

export const ItemGroupCard = (p: Props) => {
  const { isDisabled, schemaForm } = p;
  const { field, name } = p.field;

  const configureTabFields = useSelector(s => s.schemaModal?.fields);
  const treeGroupType = 'treegroup_' + field;
  const selected = useSelector(s => s.schemaModal?.selectedField);

  const isSelected = selected == treeGroupType;
  const [isOpen, setIsOpen] = React.useState(false);
  
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (isSelected && ref?.current) {
      ref.current.scrollIntoView();
    }
  }, [ref, isSelected]);
  const allFields = schemaForm
    ? p.schemaForm?.props?.fields
    : configureTabFields;

  const childrenFields = getGroupChildren(p.field, allFields).sort(
    (a, b) => (a.order || 0) - (b.order || 0)
  );

  return (
    <div
      className={cn({
        'selected-field': isSelected,
        'disabled-field': isDisabled
      })}
      ref={ref}
    >
      <div className="tree-card-container group-card">
        <div 
          className="card" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="field-col">
            <span className={`field-group-icon ${isOpen ? 'open' : 'closed'}`}>
              <Arrow direction={isOpen ? 'down' : 'right'} type="solid" />
            </span>
            <span>{name || '--'}</span>{' '}
          </div>
        </div>
        {isOpen && childrenFields.map((f, idx) => {
          return (
            <ItemFieldCardWrapper
              key={f.field}
              field={f}
              index={idx}
              schemaForm={schemaForm}
            />
          );
        })}
      </div>
    </div>
  );
};
